;(function emblaProductInitModule() {
  if (typeof window === 'undefined') return

  // (thumb sizing removed – static below-gallery layout)

  function initEmblaIn(root) {
    if (!root || typeof EmblaCarousel !== 'function') return

    const galleries = root.querySelectorAll('[data-product-gallery]')
    for (const gallery of galleries) {
      if (gallery.dataset.emblaInitialized) continue

      const mainViewport = gallery.querySelector(
        '[data-embla-main-product] .embla__viewport',
      )
      const thumbViewport = gallery.querySelector(
        '[data-embla-thumbnail-product] .embla__viewport',
      )
      if (!mainViewport || !thumbViewport) continue

      const mq = window.matchMedia('(max-width: 1279px)')
      const mainOpts = (isSmall) => ({
        loop: false,
        watchDrag: isSmall, // swipe only under 1280px
      })

      const mainEmbla = EmblaCarousel(mainViewport, mainOpts(mq.matches))
      const thumbEmbla = EmblaCarousel(thumbViewport, { watchDrag: false })

      mq.addEventListener('change', (e) =>
        mainEmbla.reInit(mainOpts(e.matches)),
      )

      function syncThumbs() {
        const selected = mainEmbla.selectedScrollSnap()
        thumbEmbla.scrollTo(selected)
        gallery
          .querySelectorAll('[data-embla-thumbnail-product] [data-thumbnail]')
          .forEach((thumb, idx) => {
            const isSelected = idx === selected
            thumb.classList.toggle('border-gold-700', isSelected)
            thumb.classList.toggle('ring-1', isSelected)
            thumb.classList.toggle('ring-gold-700', isSelected)
            thumb.setAttribute('aria-pressed', isSelected ? 'true' : 'false')
            const img = thumb.querySelector('img')
            if (img) img.classList.toggle('opacity-50', isSelected)
          })
      }
      mainEmbla.on('select', syncThumbs)
      syncThumbs()

      gallery
        .querySelectorAll('[data-embla-thumbnail-product] [data-thumbnail]')
        .forEach((thumb, idx) => {
          const activate = () => mainEmbla.scrollTo(idx, true)
          thumb.addEventListener('click', (event) => {
            event.preventDefault()
            activate()
          })
          thumb.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault()
              activate()
            }
          })
        })

      gallery.dataset.emblaInitialized = 'true'
    }
  }

  document.addEventListener('DOMContentLoaded', () => initEmblaIn(document))
  document.addEventListener('ui:hydrate', (e) => {
    const root = e.detail?.target || document
    initEmblaIn(root)
  })
  window.initProductGalleryEmbla = initEmblaIn
})()
